// Sales shown in the banner at the top of every page. Edit this list every few
// weeks: one entry per sale. `start` and `end` are inclusive, in Mountain time.
// The code must exist as an offer code on the Gumroad products it applies to.
// Preview any day by adding ?sale_date=2026-11-28 to a page URL.

export interface Sale {
  code: string;
  start: string; // YYYY-MM-DD
  end: string; // YYYY-MM-DD
  text: string;
  linkText: string;
  /** A site path like /store. */
  href: string;
}

export const SALE_TIME_ZONE = "America/Denver";

export const SALES: Sale[] = [
  {
    code: "LAUNCH20",
    start: "2026-10-31",
    end: "2026-11-14",
    text: "Launch sale: 20% off your first order of any template or bundle. Ends Nov 14.",
    linkText: "Shop templates",
    href: "/store",
  },
  {
    code: "BLACKFRIDAY30",
    start: "2026-11-27",
    end: "2026-11-30",
    text: "Black Friday through Cyber Monday: 30% off both All 30 Quiz Templates bundles.",
    linkText: "See the bundle",
    href: "/store/all-30-quiz-templates",
  },
  {
    code: "TRAINING15",
    start: "2026-12-01",
    end: "2026-12-18",
    text: "Got training budget left this year? Take 15% off any Company license through Dec 18.",
    linkText: "Shop templates",
    href: "/store",
  },
  {
    code: "NEWYEAR20",
    start: "2026-12-19",
    end: "2027-01-04",
    text: "New year sale: 20% off any template or bundle through Jan 4.",
    linkText: "Shop templates",
    href: "/store",
  },
];

/** Today as YYYY-MM-DD in Mountain time. `override` (the ?sale_date value) wins when it is a valid date. */
export function saleDay(override?: string | null, now: Date = new Date()): string {
  if (override && /^\d{4}-\d{2}-\d{2}$/.test(override)) return override;
  // en-CA formats dates as YYYY-MM-DD
  return new Intl.DateTimeFormat("en-CA", { timeZone: SALE_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}

export function activeSale(day: string, sales: Sale[] = SALES): Sale | null {
  return sales.find((s) => day >= s.start && day <= s.end) ?? null;
}
